<dx-accordion
  keyExpr="id"
  [(selectedItems)]="selectedItems"
  [dataSource]="lignesInventaire | paginate: { itemsPerPage: pageSize, currentPage: page, totalItems: totalDenrees }"
  [collapsible]="true"
  [multiple]="true"
  [deferRendering]="true"
  [noDataText]="isWaitingForHistoryParams
      ? 'En attente de la saisie complète des paramètres d\'historisation'
      : 'Pas de données'"
  id="accordion-container">

  <div *dxTemplate="let rowData of 'title'"
       class="accordion-info-container"
       [ngClass]="{'no-stock': rowData.noStock}">
    <div>
      <yo-button iconClass="fas fa-plus" buttonClass="highlight"
                 [theme]="rowData.noStock ? ButtonThemeEnum.WARNING : ButtonThemeEnum.ADD"
                 tooltip="Ajout d'un nouveau lot"
                 (onClick)="openDialogAjoutLot(rowData, $event)">
      </yo-button>
      <span>
        <strong class="highlight">{{ rowData.produitDeclinaisonCode }}</strong>
        <strong id="libelle-matiere-premiere"> {{ rowData.produitDeclinaisonLibelle }} </strong>
      </span>
    </div>

    <div class="accordion-details-info-container">
      <ng-container *ngIf="rowData.noStock">
        <span>
          <i class="fas fa-ban danger-color"></i> Pas de stock
        </span>
      </ng-container>
      <ng-container *ngIf="!rowData.noStock">
        <span>
          <strong>En stock</strong> : {{ rowData.quantiteUS }} {{ rowData.uniteDeStockage }}
        </span>

        <span>
              <strong>Qté ajustée</strong> :
            </span>
        <input (click)="onClick($event, rowData)"
               (ngModelChange)="updateQteLotsInventaire($event, rowData)"
               [ngModel]="rowData.quantiteUS">
        <span class="input-group-append">{{ rowData.uniteDeStockage }}</span>
      </ng-container>

      <span class="floatright"
            *ngIf="rowData.totalHT">
        <strong>TOTAL HT</strong> = {{ rowData.totalHT | currency:'EUR':'symbol':'1.2-4' }}
      </span>

      <span class="floatright"
            *ngIf="rowData.totalHT">
        <strong>TOTAL TTC</strong> = {{ rowData.totalTTC | currency:'EUR':'symbol':'1.2-4' }}
      </span>
    </div>
  </div>

  <div *dxTemplate="let rowData of 'item'">
    <table>
      <thead>
      <tr>
        <th class="no-space-if-empty"></th>
        <th>Lot</th>
        <th>Libellé article</th>
        <th>Zone de stockage</th>
        <th>Réceptionné le</th>
        <th>DLC/DDM</th>
        <th>U.S</th>
        <th>Qté</th>
        <th>Qté Réaj</th>
      </tr>
      </thead>
      <tbody *ngFor="let child of rowData.children">
      <tr>
        <td class="no-space-if-empty">
          <yo-button
            *ngIf="isImageButtonAvailable(child)"
            iconClass="fas fa-camera"
            buttonClass="cta-secondary"
            (onClick)="openImageDialog(child)"
            tooltip="Consulter la ou les photos"
            [label]="getImageCount(child)">
          </yo-button>
        </td>
        <td>
          {{ getLotToDisplay(child) }}
        </td>
        <td>
          {{ child.article }}
        </td>
        <td>
          <div>
            <i class="fas fa-industry"></i>{{ child.udpLibelle }}
          </div>
          <div>
            <i class="fas fa-cubes"></i>{{ child.zdsLibelle }}
          </div>
        </td>
        <td>
          {{ child.dateEntree | date:'dd/MM/yy' }}
        </td>
        <td>
          {{ child.dlc | date:'dd/MM/yy' }}
        </td>
        <td>
          {{ child.uniteStockageAbreviation }}
        </td>
        <td>
          {{ child.quantite  | number:'1.4-4' }}
        </td>
        <td class="input-column">
          <div class="input-group">
            <input type="number"
                   min="0"
                   (ngModelChange)="updateQuantityReaj($event, child)"
                   (keydown)="utils.keydownNumber($event, child,'quantiteReaj',true)"
                   [ngModel]="child.quantiteReaj">
            <div class="input-group-append">
              <span class="m-0 input-group-text" id="basic-addon2">{{ child.uniteStockageAbreviation }}</span>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</dx-accordion>

<pagination-controls
  class="text-center"
  (pageChange)="handlePageChange($event)"
  [directionLinks]="false"
  [responsive]="true"
  previousLabel="Précédent"
  nextLabel="Suivant"></pagination-controls>

<yo-dialog-lot-ajout
  [ngClass]="{'hidden-popup': !displayDialogAjoutLot}"></yo-dialog-lot-ajout>
<yo-dialog-print-inventaire
  [(displayDialog)]="displayDialogPrintInventaire"
  [searchSupplierWrapper]="ssw">
</yo-dialog-print-inventaire>

<yo-image-list-popup
  [isOpened]="isImagePopupOpened"
  (onClose)="onImagePopupClose($event)"
  [values]="selectedLot?.images"
  [disabled]="true">
</yo-image-list-popup>

<dx-load-panel
  #load
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: elementRef.nativeElement }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [message]="loaderMessage">
</dx-load-panel>
